import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";

import Button from "../../../../../../components/common/PL/Button/Button";
import TextInput from "../../../../../../components/common/PL/TextInput/TextInput";

import "./NuevaEmpresaModal.css";

export type NuevaEmpresaData = {
  name: string;
};

type NuevaEmpresaModalProps = {
  open: boolean;
  prefillNombre?: string;
  onClose: () => void;
  onSubmit?: (data: NuevaEmpresaData) => Promise<boolean>;
};

const NuevaEmpresaModal: React.FC<NuevaEmpresaModalProps> = ({
  open,
  prefillNombre = "",
  onClose,
  onSubmit,
}) => {
  const [nombre, setNombre] = React.useState<string>("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setNombre(prefillNombre);
    }
  }, [open, prefillNombre]);

  const handleClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  const handleSubmit = async () => {
    if (!nombre.trim() || isSubmitting) return;
    setIsSubmitting(true);
    const success = (await onSubmit?.({ name: nombre.trim() })) ?? true;
    setIsSubmitting(false);
    if (success) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ className: "nuevaEmpresaModalCard" }}
      fullWidth
    >
      <DialogTitle disableTypography className="nuevaEmpresaModalTitle">
        Nueva empresa transportista
      </DialogTitle>
      <DialogContent className="nuevaEmpresaModalContent">
        <div className="nuevaEmpresaModalSection">
          <span className="nuevaEmpresaModalSectionLabel">Nombre *</span>
          <TextInput
            value={nombre}
            onChange={setNombre}
            placeholder="-completar-"
            leftIcon={<LocalShippingOutlinedIcon fontSize="small" />}
            disabled={isSubmitting}
          />
        </div>

        <div className="nuevaEmpresaModalNote">
          La empresa se creará sin autorizaciones. Podrás solicitar una autorización luego de
          seleccionarla.
        </div>
      </DialogContent>
      <DialogActions className="nuevaEmpresaModalActions">
        <Button
          variant="outline"
          onClick={handleClose}
          className="nuevaEmpresaModalButton"
          disabled={isSubmitting}
        >
          Cancelar
        </Button>
        <Button
          variant="neutral"
          onClick={handleSubmit}
          className="nuevaEmpresaModalButton"
          disabled={!nombre.trim() || isSubmitting}
          loading={isSubmitting}
        >
          Crear empresa
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NuevaEmpresaModal;
